<template>
      <div class="row justify-content-center">
      <div class="col-11">
        <img src="./../assets/logo.png" alt="Vue-Logo" class="d-block mx-auto">
        <!-- modal -->
          <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
              <!-- color="red lighten-2"
          dark -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
         color="primary"
          v-bind="attrs"
          v-on="on"
          @click="openModal"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Explanation
        </v-card-title>

        <v-card-text>
          Here are some explanation for this system 😉 <br><br> First if you want to make a new task then press on input box and then write a task and then press ( Enter key or ADD NEW TASK button )😁 <br><br> Second if you have already done your task then press ( ✔ ) button <br><br> Finally if you want to delete your task then press ( 🗑 ) button
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
             Understand
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

        <form @submit.prevent="addItems">
          <label>New Task</label>
          <input type="text" class="form-control mt-1" v-model="task">
          <v-btn
            elevation="2"
            class="mt-3"
            dark
            type="submit"
          >Add New Task</v-btn>
          <!-- <button class="btn btn-dark mt-3" type="submit"></button> -->
        </form>
      </div>
    </div>
</template>

<script>
export default {
  name : "AddTask",
  data: ()=>({
    task : "",
    dialog: false,
  }),
  methods :{
    addItems(){
      if(this.task.length === 0){
        return alert("You Need To Fill the Task!")
      }
      const taskItems = {
        task : this.task,
        completed : false,
      };
      this.$emit("addTask",taskItems);
      this.task = "";
       this.$notify({
        group: 'foo',
        title: 'Make A Task',
        text: 'Hello user! You just make a task 😎',
        type: 'info',
      });
    },
    openModal(){
      this.dialog = true
    }
  }
}
</script>

<style>

</style>